<admin-page-simple-content
    [icon]="'library_books'"
    [pageError]="pageError"
    [pageStatus]="pageStatus"
    [title]="'Settings: Library'"
>
    @if (storeConfig) {
        <div class="content">
            <p>Any changes made to the configuration may take up to 2 minutes to become effective.</p>
            <form #form="ngForm" (ngSubmit)="save()">
                <mat-form-field>
                    <mat-label>Default library package</mat-label>
                    <input
                        matInput
                        [(ngModel)]="storeConfig.defaultLibraryPackage"
                        name="defaultLibraryPackage"
                        placeholder="mediaclip/default"
                        pattern="^[a-zA-Z0-9\-_]+\/[a-zA-Z0-9\-_]+$"
                        required
                        autocomplete="off"
                    />
                    <mat-error>Value must be in the form <code>company/package</code></mat-error>
                    <mat-hint>
                        When launching a project, which library package should be used. Can be overridden
                        <a
                            class="external"
                            href="https://doc.mediaclip.ca/hub/api/projects/create/"
                            rel="external"
                            target="_blank"
                        >
                            by project
                            <mat-icon>open_in_new</mat-icon>
                        </a
                        >.
                    </mat-hint>
                </mat-form-field>
                <div class="config-complex">
                    <div class="header">
                        Library Branches
                    </div>
                    <div class="body">
                        <p>This allow you to configure the library branches to use. By default the <code>production</code> branch is used.
                            Library branches are managed in the <a [routerLink]="['/libraries']">library deployment page</a>
                        </p>
                        @if (storeConfig.defaultLibraryBranches) {
                            <p>
                                If you need to test this before applying the changes, you can use this value:
                                <code adminCopyToClipboard>{{ storeConfig.defaultLibraryBranches }}</code> as specified in the
                                <a
                                    class="external"
                                    href="https://doc.mediaclip.ca/hub/library/library-branching/"
                                    target="_blank">documentation
                                    <mat-icon>open_in_new</mat-icon>
                                </a>.
                            </p>
                        }

                        <admin-library-branches-selector [(libraryBranches)]="storeConfig.defaultLibraryBranches" />
                    </div>
                </div>

                <admin-save-button [disabled]="!form.valid" [pageStatus]="pageStatus"></admin-save-button>
            </form>
        </div>
    }

    <div>
        @if (pageStatus === "saveError" && pageError) {
            <admin-error [error]="pageError"></admin-error>
        }
    </div>
</admin-page-simple-content>
